module.exports = __webpack_public_path__ + "media/images/badge/a-bersaglio-0d4e3716d796eac38aa11576c2519809.png";